import React, { useState } from "react";
import {
  Box,
  Typography,
  FormControlLabel,
  Switch,
  FormControl,
  Select,
  MenuItem,
  Button,
} from "@mui/material";

import { BASE_URL } from "../../../../constant/apiUrl";
import { formatDate } from "../../../../utils/function";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../utils/Toast/toast";
import { useDispatch, useSelector } from "react-redux";
import { setFetchPending } from "../../../../slices/invitationSlice";
import { postAPI } from "../../../../API/ApiService";
import styles from "./historyandPendingStyles";

const AccessHistory = React.memo(
  ({ data, user }) => {
    const dispatch = useDispatch();
    const [access, setAccess] = useState(data.isGrantedAccess);
    const { fetch } = useSelector((state) => state.invitation);
    const [accessType, setAccessType] = useState(data.accessType);

    const handleSave = async () => {
      const newRoleId = user.filter((item) => item.name === accessType);

      try {
        const response = await postAPI(
          `${BASE_URL}/admin/users/grant-revoke-access`,
          {
            userId: data?.id,
            roleId: newRoleId[0]?.id,
            userType: data?.userType,
            isGrantedAccess: access,
            email: data.email,
            roleName: accessType,
            contactNo: Number(data.contactNo),
          }
        );
        if (response?.status === 200) {
          showSuccessToast("Save successfull");
          dispatch(setFetchPending(!fetch));
        }
      } catch (error) {
        console.error(
          "Error saving data:",
          error.response ? error.response.data : error.message
        );
        showErrorToast(
          `${error.response ? error.response.data : error.message}`
        );
      }
    };

    const nweUser = user.filter(
      (item) => item.name.toLowerCase() !== "external"
    );

    return (
      <Box sx={styles.container}>
        <Box sx={styles.section}>
          <Box sx={styles.card}>
            <Box sx={{ display: "flex", gap: "8px" }}>
              <Box
                sx={{ width: "100%", fontFamily: "Inter", color: "#616161" }}
              >
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "700", marginBottom: 2 }}
                >
                  Access
                </Typography>

                <Box
                  display="flex"
                  alignItems="center"
                  sx={{ marginBottom: 2 }}
                >
                  <Typography variant="body1" sx={{ marginRight: 2 }}>
                    Grant access?
                  </Typography>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={access}
                        onChange={() => setAccess((prevAccess) => !prevAccess)}
                        color="primary"
                      />
                    }
                    label={access ? "Yes" : "No"}
                  />
                </Box>

                <Box display="flex" sx={{ marginBottom: 2, gap: 1 }}>
                  <Typography variant="body1" sx={{ fontWeight: "700" }}>
                    Last access
                  </Typography>
                  <Typography variant="body1">
                    {data?.lastModifiedDate === null
                      ? null
                      : formatDate(data?.lastModifiedDate)}
                  </Typography>
                </Box>

                <Box
                  display="flex"
                  alignItems="center"
                  sx={{ marginBottom: 2 }}
                >
                  <Box sx={{ marginRight: 2 }}>
                    <Typography variant="body2" sx={{ marginBottom: 0.5 }}>
                      Access type
                    </Typography>
                    <FormControl sx={{ minWidth: 400 }}>
                      {accessType?.toLowerCase() === "external" ? (
                        // If accessType is 'External', show a disabled text display
                        <Typography
                          sx={{
                            height: "32px",
                            lineHeight: "32px",
                            backgroundColor: "#FBFCFE",
                            paddingX: "12px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                          }}
                        >
                          {accessType}
                        </Typography>
                      ) : (
                        // If not 'External', show the dropdown
                        <Select
                          value={accessType}
                          onChange={(event) =>
                            setAccessType(event.target.value)
                          }
                          sx={{ height: "32px", backgroundColor: "#FBFCFE" }}
                        >
                          <MenuItem value={null}>Select</MenuItem>
                          {nweUser
                            ?.filter(
                              (item) => item.name.toLowerCase() !== "external"
                            ) // Exclude 'External' from dropdown
                            .map((item) => (
                              <MenuItem key={item.id} value={item?.name}>
                                {item?.name}
                              </MenuItem>
                            ))}
                        </Select>
                      )}
                    </FormControl>
                  </Box>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSave}
                    disabled={accessType === null}
                    sx={{
                      bgcolor: "#005CBC",
                      fontWeight: 700,
                      borderRadius: "24px",
                      textTransform: "none",
                      marginTop: 3,
                    }}
                  >
                    Save
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    );
  },
  (prevProps, nextProps) => {
    return (
      JSON.stringify(prevProps.data) === JSON.stringify(nextProps.data) &&
      prevProps.user === nextProps.user
    );
  }
);

export default AccessHistory;
